const getTableIndex = (index: number, page: number, pageSize: number) => {
  return pageSize * (page - 1) + index;
};

export default getTableIndex;
